import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ContactCustomerModal from 'ContactCustomerModal';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import { updatePhaseTask } from 'actionCreators/phase';
import PhaseTask from './phase_task';

export class InstallContactCustomerPhaseTask extends PhaseTask {
  isDisabled = () => false

  onClick = () => {
    if (this.props.task.status === 'complete') {
      this.toggleStatus();
    } else {
      this.setState({ modalActive: true });
    }
  }

  renderChildren = () =>
    <ContactCustomerModal
      phase={this.props.phase}
      task={this.props.task}
      active={this.state.modalActive}
      completeTask={this.completeTask}
      onClose={this.handleClose}
      showNonResponsive={false}
      isInstall
    />
}

InstallContactCustomerPhaseTask.propTypes = {
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
};

const install_contact_customer = connect(() => ({}), {
  updatePhaseTask,
})(InstallContactCustomerPhaseTask);

export {
  install_contact_customer,
  install_contact_customer as workorder_contact_customer,
};



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/install_contact_customer.jsx